export enum WebSocketMessageTypes {
	hello = "hello",
	ping  = "ping",
	timeout = "timeout",
	logout = "logout",
	bye = "bye",
	pretimeout = "pretimeout"
}